import { defaultSection } from './default'
import { objToList } from './index'
import { getFormData } from './form'
import { getField } from './fields'

/**
 * 根据默认配置从接口数据捞出需要的数据(接口会返回所有数据)
 * @param {*} data 
 */
export const generateSections = (data = {}) => {
    if (Object.keys(data).length <= 0) return
    const formFields = objToList(data)
    // 淘特加上重量字段
    formFields.push({
        children: null,
        dataId :  null,
        defaultValue: '1',
        id: null,
        label: '重量',
        name: 'itemWeight',
        options: null,
        rules: { requiredRule: "false" },
        type: 'INPUT'
    })
    const index  = formFields.findIndex(item => item.name == 'tbDeliveryTime')
    const subStocIndex = formFields.findIndex(item => item.name == 'subStock');
    let tbDeliveryTimeItem = formFields.find(item => item.name == 'tbDeliveryTime');
    let subStockItem = formFields.find(item => item.name == 'subStock');

    formFields[index] = {
        ...tbDeliveryTimeItem,
        rules: {
            requiredRule: 'true',
            tipRule: ''
        }
    }
    formFields[subStocIndex] = {
        ...subStockItem,
        rules: {
            requiredRule: 'true',
            tipRule: ''
        }
    };
    formFields.splice(index, 0 , {
        children: null,
        id: null,
        defaultValue: null,
        label: '',
        name: 'openSkuDeliveryTime',
        options: [{
            dependGroup: null,
            displayName: '是',
            value : "1"
        },
       {
            dependGroup: null,
            displayName: '否',
            value : "0"
        }
       ],
        rules: [],
        type: 'SINGLECHECK'
    })

    // 对采购地做rule处理，将globalStock的rules移动至子中的globalStockNav
    let globalStock = formFields.find(item => item.name === 'globalStock')
    if (globalStock) {
        let globalStockNav = globalStock.children.find(item => item.name === 'globalStockNav')
        if (globalStockNav) {
            globalStockNav.rules = {
                ...globalStockNav.rules,
                ...globalStock.rules
            }
            globalStock.rules = {}
        }
    }

    // 按照默认配置获取数据
    const formSections = defaultSection.reduce((list, item) => {
        let fields = item.fieldsMatch.reduce((fields, { reg }) => {
            let list = formFields.filter(item2 => reg.test(item2.name)) // 捞需要显示的数据
            let field = getField(list) // 生成 field
            return fields.concat(field)
        }, [])

        return list.concat({
            title: item.title,
            children: fields
        })
    }, [])

    let formData = getFormData(formSections); // 生成 form 表单对象

    return { formData, formSections }
}

export const skuDeliveryTime = (data = {}) => {
    if(data['sku'] && data['sku'].children && data['sku'].children.length) {
        let children = data['sku'].children;
        let skuDeliveryTimeOptions = [];
        children.forEach(item => {
            if(item.name == 'skuDeliveryTime') {
                skuDeliveryTimeOptions = [item.options]
            }
        });
        return skuDeliveryTimeOptions
    }
    return []
}
